
import { Sale } from "@/models/base";
import { SendcloudService } from "@/services/sendcloud-service";
import { SaleSendCloudParcel } from "@/utils/sendcloud/sale-send-cloud-parcel";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			parcels: [] as SaleSendCloudParcel[],
			fetching: true
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	methods: {
		openParcel(item:SaleSendCloudParcel){
			item.openInSendcloud();
		},
		close(){
			this.$emit("close");
		}
	},
	async mounted(){
		this.parcels = await SendcloudService.getSaleSendcloudParcels(this.sale);
		this.fetching = false;
	},
	i18nEx: {
		componentPrefix: "components.sendcloud"
	}
});
